import { useEffect } from "react";
import { useManufacturingDictateSession } from "./useManufacturingDictateSession";

const idleMicClass =
  "inline-flex items-center gap-1 rounded-md border px-2 py-1 text-[11px] font-medium transition disabled:cursor-not-allowed disabled:opacity-60 border-violet-300 bg-violet-50 text-violet-800 hover:bg-violet-100 dark:border-violet-700 dark:bg-violet-950/40 dark:text-violet-200 dark:hover:bg-violet-900/40";
const recordingMicClass =
  "inline-flex items-center gap-1 rounded-md border px-2 py-1 text-[11px] font-medium transition disabled:cursor-not-allowed disabled:opacity-60 border-red-300 bg-red-50 text-red-700 hover:bg-red-100 dark:border-red-700 dark:bg-red-950/40 dark:text-red-200 dark:hover:bg-red-900/40";

/** Compact mic that appends a finished dictation chunk into an external text field. */
export function ManufacturingNamedVariantDictateAppend({
  onAppend,
  disabled,
}: {
  onAppend: (chunk: string) => void;
  disabled?: boolean;
}) {
  const session = useManufacturingDictateSession();
  const recording = session.state === "recording";

  useEffect(() => {
    if (session.state !== "stopped") return;
    const captured = session.transcript.trim();
    session.reset();
    if (captured) onAppend(captured);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only on stop transition
  }, [session.state]);

  if (!session.isSupported) {
    return (
      <span className="text-[10px] text-gray-500 dark:text-zinc-400">Mic unavailable</span>
    );
  }

  return (
    <button
      type="button"
      disabled={Boolean(disabled)}
      aria-pressed={recording}
      aria-label={recording ? "Stop dictation" : "Dictate AI instructions"}
      title={recording ? "Stop dictation" : "Dictate AI instructions"}
      className={recording ? recordingMicClass : idleMicClass}
      onClick={() => (recording ? session.stop() : session.start())}
    >
      {recording ? "Stop" : "Dictate"}
    </button>
  );
}
